import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=1c98e4de&scoped=true"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"
import style0 from "./Archive.vue?vue&type=style&index=0&id=1c98e4de&prod&scoped=true&lang=css"
import style1 from "./Archive.vue?vue&type=style&index=1&id=1c98e4de&prod&lang=css"
import style2 from "./Archive.vue?vue&type=style&index=2&id=1c98e4de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98e4de",
  null
  
)

export default component.exports